import React from 'react'
import { headerItem } from '../const';

import styles from '../styles/index.module.scss';

export const FlyingTableHeader: React.FC = () => {
  return (
    <thead>
      <tr className={styles.header_row}>
        {
          headerItem.map((item) => (
            <th key={item}>
              {item}
            </th>
          ))
        }
      </tr>
    </thead>
  )
}
